/*
 *  Pinned Images
 *    Scripts to control the pinned images click/class toggle.
 *
 *  Version:
 *    1.0.0 - 2020/09/01
 */

import { register, ShopifySection} from './ShopifySection';

//Selectors
export const CONTAINER_SELECTOR = '[data-pinned-images]';
export const PIN_OUTER_SELECTOR = '[data-pinned-images-pin-outer]';
export const PIN_SELECTOR = '[data-pinned-images-pin]';
export const CYCLE_SPEED = 'data-border-speed';

export const CLASS_VISIBLE = 'is-visible';
export const CLASS_HAS_BORDER = 'has-border';

export class PinnedImages extends ShopifySection {
  constructor(container) {
    super(container);

    this.cycleSpeed = container.find(`[${CYCLE_SPEED}]`).attr(CYCLE_SPEED) || 4000;
    this.pinOuters = container.find(PIN_OUTER_SELECTOR);

    container.on('click', PIN_SELECTOR, e => this.onPinClick(e));
    // container.on('mouseenter', PIN_SELECTOR, e => this.onPinEnter(e));
    // container.on('mouseleave', PIN_SELECTOR, e => this.onPinExit(e));
    // this.circleCycleBorder();
  }

  onPinEnter(e) {
    clearInterval(this.cycle);
    this.container.find(PIN_SELECTOR).removeClass(CLASS_HAS_BORDER);
  }

  onPinExit(e) {
    this.circleCycleBorder();
  }

  onPinClick(e) {
    e.preventDefault();
    e.stopPropagation();
    let outer = $(e.currentTarget).parents(PIN_OUTER_SELECTOR);

    if(outer.hasClass(CLASS_VISIBLE)) {
      outer.removeClass(CLASS_VISIBLE);
      return;
    }

    this.pinOuters.removeClass(CLASS_VISIBLE);
    outer.addClass(CLASS_VISIBLE);
  }

  circleCycleBorder() {
    let index = 0;

    if (!this.pinOuters) return;

    this.cycle = setInterval(_ => {
      this.container.find(PIN_SELECTOR).removeClass(CLASS_HAS_BORDER);
      $(this.pinOuters[index]).find(PIN_SELECTOR).addClass(CLASS_HAS_BORDER);
      index++;

      if (index >= this.pinOuters.length) {
        index = 0;
      }
    }, this.cycleSpeed);
  }
}

register(CONTAINER_SELECTOR, PinnedImages);